import useVisibilityStore from "../store/visibilityStore";

export default class EmployeeHelper {
    static async CheckLoadSkillsExperience(apiProvider) {
        const { visibilityRules, fetchVisibilityRules, allPropsPresent } = useVisibilityStore.getState();

        if (visibilityRules && allPropsPresent()) {
            return visibilityRules.loadSkillsExperience === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.loadSkillsExperience ?? false;
    }

    static async CheckLoadPreviousProjects(apiProvider) {
        const { visibilityRules, fetchVisibilityRules, allPropsPresent } = useVisibilityStore.getState();

        if (visibilityRules && allPropsPresent()) {
            return visibilityRules.loadPreviousProjects === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.loadPreviousProjects ?? false;
    }

    static async CheckLoadPayslips(apiProvider) {
        const { visibilityRules, fetchVisibilityRules, allPropsPresent } = useVisibilityStore.getState();

        if (visibilityRules && allPropsPresent()) {
            return visibilityRules.loadPayslipsAndTaxes === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.loadPayslipsAndTaxes ?? false;
    }

    static async CheckShowLicensePlates(apiProvider) {
        const { visibilityRules, fetchVisibilityRules } = useVisibilityStore.getState();

        if (visibilityRules) {
            return visibilityRules.showLicensePlates === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.showLicensePlates ?? false;
    }

    static async CheckLoadOboControl(apiProvider) {
        const { visibilityRules, fetchVisibilityRules } = useVisibilityStore.getState();

        if (visibilityRules) {
            return visibilityRules.loadOnBehalfOfControl === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.loadOnBehalfOfControl ?? false;
    }

    static async CheckLoadOboManager(apiProvider) {
        const { visibilityRules, fetchVisibilityRules } = useVisibilityStore.getState();

        if (visibilityRules) {
            return visibilityRules.loadOnBehalfOfManager === true;
        }

        await fetchVisibilityRules(apiProvider);
        return useVisibilityStore.getState().visibilityRules?.loadOnBehalfOfManager ?? false;
    }

    static async UpdateVisibilityRules(apiProvider) {
        const { fetchVisibilityRules } = useVisibilityStore.getState();
        await fetchVisibilityRules(apiProvider);
    }
}